const state = {
  summary: {
    global: {
      TotalConfirmed: 0,
      TotalDeaths: 0,
      TotalRecovered: 0,
      NewConfirmed: 0,
      NewDeath: 0,
      NewRecovered: 0,
      ActiveCases: 0
    },
    date: null,
    countries: [
      {
        TotalConfirmed: 0,
        TotalDeaths: 0,
        TotalRecovered: 0,
        NewConfirmed: 0,
        NewDeath: 0,
        NewRecovered: 0,
        ActiveCases: 0
      }
    ]
  }
};

const getters = {
  getGlobal(state) {
    return state.summary.global; 
  },
  getCountries(state) {
    const totalCases = (a,b) => {
      return b.TotalConfirmed - a.TotalConfirmed;
    } 
    return state.summary.countries.sort(totalCases).slice(0, 30);
  }
};

const actions = {
  fetchSummary({ commit, state}) {
    fetch('https://api.covid19api.com/summary')
      .then(res => res.json())
      .then(data => {commit('setSummary', data)})
      .catch(err => console.log('Fetch Error: ', err));
  }
};

const mutations = {
  setSummary(state, payload) {
    const { Global, Countries, Date } = payload;
    const getActiveCases = (data) => {
      const { TotalConfirmed, TotalDeaths, TotalRecovered } = data;
      return (TotalConfirmed - TotalDeaths - TotalRecovered);
    }

    const global = { 
      ...Global,
      ActiveCases: getActiveCases(Global)
    }

    const countries = Countries.map(country => {
      return { ...country, ActiveCases: getActiveCases(country) };
    })


    state.summary = {...state.summary, date: Date, global: global, countries: countries };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};